<template>
  <div><h2 class="elr-card-title">Herd</h2></div>
</template>

<script>
export default {
  name: 'HerdCard'
}
</script>
